module.exports = __webpack_public_path__ + "static/media/strongher13.3980c7a2.jpg";